import { useContext } from "react";
import { ProfileMenu, TopBar, TopBarDivider, TopBarSwitcher } from "@ka/webcomponents/nav";
import { useKaEmployee } from "../../userAccess/kaEmployee/useKaEmployee";
import { LoadPassLogo } from "../../common/LoadPassLogo";
import { SelectedSiteContext } from "./KAEmployeeContainer";
import { Site } from "../../requests/employee/useGetSites";

export function KAEmployeeTopBar({ sites }: { sites: Site[] }) {
  const { selectedSite, setSelectedSite } = useContext(SelectedSiteContext);
  const user = useKaEmployee();
  const sortedSites = [...sites].sort(alphabeticallyByCity);

  return (
    <TopBar brand={<LoadPassLogo to={user.canViewOrders ? '/dashboard' : '/sites'} />}>
      <TopBarSwitcher
        heading="Site"
        placeholder="Select Site"
        selected={selectedSite}
        options={sortedSites}
        toOption={toOption}
        onSelect={setSelectedSite} />
      <TopBarDivider />
      <ProfileMenu
        email={user.email}
        onSignOut={() => user.signOut()}
        badges={<span className="badge bg-soft-info text-info">Kahler Employee</span>} />
    </TopBar>
  );
}

const toOption = (site: Site) => ({ id: site.id, name: `${site.city}, ${site.state}` });

const alphabeticallyByCity = (a: Site, b: Site) => a.city.localeCompare(b.city);
